import { FieldSet } from "@/components/utils/useFieldSet";
import { JobAppPersonalInformationRequest } from "../../../api-docs";
import { TextInput } from "@/flokit/compound/inputs/text-input/text-input";

export const PersonalInfoFragment = (
  props: {
    firstNameRequired?: boolean;
    lastNameRequired?: boolean;
    emailRequired?: boolean;
    phoneNumberRequired?: boolean;
    linkedInRequired?: boolean;
    enableEmail?: boolean;
    onChange: (
      value: string,
      field: keyof JobAppPersonalInformationRequest,
    ) => void;
  } & FieldSet<JobAppPersonalInformationRequest>,
) => {
  return (
    <div className="grid gap-x-6 gap-y-5 pb-4 sm:grid-cols-2">
      <TextInput
        label="First Name"
        name="firstName"
        onChange={(v) => props.onChange(v, "firstName")}
        value={props.values.firstName}
        isRequired={props.firstNameRequired}
        onBlur={props.onBlur("firstName")}
        validationMessage={props.validationMsg.firstName}
        shouldShowValidation={props.validation.firstName}
      />

      <TextInput
        label="Last Name"
        name="lastName"
        onChange={(v) => props.onChange(v, "lastName")}
        value={props.values.lastName}
        isRequired={props.lastNameRequired}
        onBlur={props.onBlur("lastName")}
        validationMessage={props.validationMsg.lastName}
        shouldShowValidation={props.validation.lastName}
      />

      <TextInput
        label="Email"
        name="email"
        onChange={(v) => props.onChange(v, "email")}
        value={props.values.email}
        isRequired={props.emailRequired}
        onBlur={props.onBlur("email")}
        validationMessage={props.validationMsg.email}
        shouldShowValidation={props.validation.email}
        isDisabled={!props.enableEmail}
      />

      <TextInput
        label="Phone Number"
        name="phoneNumber"
        onChange={(v) => props.onChange(v, "phoneNumber")}
        value={props.values.phoneNumber}
        isRequired={props.phoneNumberRequired}
        onBlur={props.onBlur("phoneNumber")}
        validationMessage={props.validationMsg.phoneNumber}
        shouldShowValidation={props.validation.phoneNumber}
        type="tel"
      />

      <TextInput
        label="LinkedIn"
        name="linkedIn"
        onChange={(v) => props.onChange(v, "linkedIn")}
        value={props.values.linkedIn}
        isRequired={props.linkedInRequired}
        placeholder="https://www.linkedin.com/in/your-profile"
        onBlur={props.onBlur("linkedIn")}
        validationMessage={props.validationMsg.linkedIn}
        shouldShowValidation={props.validation.linkedIn}
      />
    </div>
  );
};
